import { render, staticRenderFns } from "./NewLanding.vue?vue&type=template&id=7caa1c19&"
import script from "./NewLanding.vue?vue&type=script&lang=js&"
export * from "./NewLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports